"use client";
import { FeaturesListItemProps } from "components/industries/features-list-section";
import { SectionTemplate } from "./section-template";
import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import Image from "next/legacy/image";
import { ThemeColor } from "lib/gcms/theme-color";

export interface ProductBenefitsSectionProps {
  bg: ThemeColor;
  textColor: ThemeColor;
  title: string;
  featuresList: FeaturesListItemProps[];
  subtitle?: string;
}
export default function ProductBenefitsSection(
  props: ProductBenefitsSectionProps,
) {
  return (
    <SectionTemplate bg={props.bg}>
      <Box borderRadius={"3xl"}>
        <Heading
          as={"h2"}
          fontSize={{
            base: 26,
            md: 34,
            lg: 38,
            xl: 45,
          }}
          fontWeight="bold"
          lineHeight={1.2}
          mb={{
            base: 6,
            lg: 8,
          }}
          textAlign={{
            base: "left",
            lg: "center",
          }}
        >
          {props.title}
        </Heading>
        {props.subtitle && (
          <Text
            mb={{
              base: 8,
              md: 10,
              lg: 12,
            }}
            fontSize={{
              base: "14px",
              md: "16px",
              lg: "17px",
              xl: "18px",
            }}
            textAlign={"left"}
          >
            {props.subtitle}
          </Text>
        )}
        <Flex
          gap={{
            base: 10,
            lg: 20,
          }}
          flexDir={{
            base: "column",
            lg: "row",
          }}
          align={{
            base: "center",
            lg: "unset",
          }}
        >
          {props.featuresList.map((item, idx) => (
            <Box
              key={`product-benefit-${idx}`}
              textAlign={"center"}
              w={{
                base: "70%",
                sm: "50%",
                md: "40%",
                lg: "30%",
              }}
            >
              <Flex borderRadius={"full"} justify={"center"} align={"center"}>
                {item.icon && (
                  <Box
                    h={{
                      base: "50px",
                      lg: "70px",
                    }}
                    w={{
                      base: "50px",
                      lg: "70px",
                    }}
                  >
                    <Image
                      {...item.icon}
                      src={item.icon.url}
                      width={100}
                      height={100}
                      alt={item?.alt}
                    />
                  </Box>
                )}
              </Flex>
              <Text
                fontWeight={"bold"}
                fontSize={{
                  base: "16px",
                  md: "18px",
                  lg: "19px",
                  xl: "20px",
                }}
                mt={{
                  base: 4,
                  lg: 6,
                }}
              >
                {item.title}
              </Text>
            </Box>
          ))}
        </Flex>
      </Box>
    </SectionTemplate>
  );
}
